import _styled from "@emotion/styled-base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React, { useContext } from 'react';
import Media from 'react-media';
import { JsonLd } from 'react-schemaorg'; // Import Components

import { CategoryBody } from './CategoryBody';
import { AdsenseContext, ArticleSchema, ContentHeroBanner, DfpAdUnitSetup, Layout } from '@jelly/components';
import { SECTION_CONTAINER, SECTION_WIDGET } from '../constants'; // Styled Components via Emotion

var CategoryContainer = _styled("div", {
  target: "e1mw9c70",
  label: "CategoryContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "v2kfba",
  styles: "height:100%;width:100%;"
} : {
  name: "v2kfba",
  styles: "height:100%;width:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

/**
 * This is the Category Template Wrapper
 */
export function Category(props) {
  var _sections$find, _sections$find$widget;

  var author = props.author,
      breadcrumbs = props.breadcrumbs,
      canonical = props.canonical,
      channels = props.channels,
      docType = props.docType,
      guid = props.guid,
      hasVwo = props.hasVwo,
      lastModified = props.lastModified,
      published = props.published,
      meta = props.meta,
      sections = props.sections,
      structuredData = props.structuredData,
      thumbnail = props.thumbnail,
      title = props.title,
      tocElements = props.tocElements; // join all container sections for the article schema data

  var content = sections.filter(function (section) {
    return section.type === SECTION_CONTAINER;
  }).map(function (section) {
    return section.container.html;
  });
  var widgetId = (_sections$find = sections.find(function (section) {
    return section.type === SECTION_WIDGET;
  })) === null || _sections$find === void 0 ? void 0 : (_sections$find$widget = _sections$find.widget) === null || _sections$find$widget === void 0 ? void 0 : _sections$find$widget.widgetId;

  var _useContext = useContext(AdsenseContext),
      adsenseMediaQuery = _useContext.adsenseMediaQuery,
      hasAdsense = _useContext.hasAdsense;

  return /*#__PURE__*/React.createElement(CategoryContainer, null, /*#__PURE__*/React.createElement(Layout, {
    meta: meta,
    hasVwo: hasVwo
  }, /*#__PURE__*/React.createElement(JsonLd, {
    item: ArticleSchema({
      thumbnail: thumbnail,
      content: content.join(' '),
      author: author,
      canonical: canonical,
      breadcrumbs: breadcrumbs,
      published: published,
      lastModified: lastModified,
      title: title
    })
  }), structuredData && /*#__PURE__*/React.createElement(JsonLd, {
    item: structuredData
  }), /*#__PURE__*/React.createElement(ContentHeroBanner, {
    author: author,
    breadcrumbs: breadcrumbs,
    date: lastModified,
    published: published,
    header: title,
    imageSrc: thumbnail
  }), /*#__PURE__*/React.createElement(CategoryBody, {
    docType: docType,
    guid: guid,
    sections: sections,
    title: title,
    tocElements: tocElements,
    widgetId: widgetId
  }), hasAdsense && /*#__PURE__*/React.createElement(Media, {
    query: adsenseMediaQuery,
    defaultMatches: false
  }, function (matches) {
    return matches && /*#__PURE__*/React.createElement(DfpAdUnitSetup, {
      channels: channels,
      docType: docType,
      guid: guid
    });
  })));
}